import { FilterTranslationMap } from '../model';

import './FilterDialogActions.scss';

export type FilterDialogActionsProps = {
	numberOfResults: number | undefined;
	translationMap: FilterTranslationMap;
	resetFilter: () => void;
	submitHandler: () => void;
	cancelHandler: () => void;
};

const FilterDialogActions: React.FC<FilterDialogActionsProps> = ({
	numberOfResults,
	translationMap,
	resetFilter,
	submitHandler,
	cancelHandler,
}) => {
	const getDesktopSubmitText = () => {
		if (numberOfResults === 1) {
			return translationMap.submitForDesktopSingle;
		} else {
			return translationMap.submitForDesktopPlural.replace(
				'{0}',
				`${numberOfResults || ''}`
			);
		}
	};

	return (
		<div className="blk-ac-filter-dialog-actions blk-ac-modal-footer">
			<button className="blk-ac-secondary-button" onClick={cancelHandler}>
				{translationMap.cancel}
			</button>
			<div className="blk-ac-button-group">
				<button className="blk-ac-secondary-button" onClick={resetFilter}>
					{translationMap.clearAll}
				</button>
				<button
					className="blk-ac-primary-button display-on-mobile"
					onClick={submitHandler}
				>
					{translationMap.submitForMobile}
				</button>
				<button
					className="blk-ac-primary-button display-on-desktop"
					onClick={submitHandler}
				>
					{getDesktopSubmitText()}
				</button>
			</div>
		</div>
	);
};

export default FilterDialogActions;
